import { Controller } from "@hotwired/stimulus"

// Greys out and skips the recommendation question when the booking is a
// pre-booked package (the front office did not need to recommend the spa).
export default class extends Controller {
  static targets = ["toggle", "recommendationBlock", "recommendationInput"]

  connect() {
    this.update()
  }

  update() {
    const prebooked = this.toggleTarget.value === "true"

    this.recommendationBlockTarget.classList.toggle("opacity-50", prebooked)
    this.recommendationBlockTarget.classList.toggle("pointer-events-none", prebooked)
    this.recommendationInputTarget.readOnly = prebooked
    if (prebooked) this.recommendationInputTarget.value = ""
  }
}
